import {Inject, NgModule} from '@angular/core';
import {BotatoChatComponent} from './botato-chat/botato-chat.component';
import {BotatoWidgetComponent} from './botato-widget/botato-widget.component';
import {BotatoChatMessageComponent} from './botato-chat-message/botato-chat-message.component';
import {ContenteditableModelDirective} from './contenteditable-model.directive';
import {CommonModule} from '@angular/common';
import {TextMessageComponent} from './botato-chat-message/message-type/text-message/text-message.component';
import {BotatoChatMessageDirective} from './botato-chat-message/botato-chat-message.directive';
import {TypingIndicatorComponent} from './botato-chat-message/message-type/typing-indicator/typing-indicator.component';
import {SelectionListMessageComponent} from './botato-chat-message/message-type/selection-list-message/selection-list-message.component';
import {ImageMessageComponent} from './botato-chat-message/message-type/image-message/image-message.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {BotatoConfig} from './botato.config';
import {EmojiPipe} from './emoji.pipe';
import {BotatoChatInputComponent} from './botato-chat-input/botato-chat-input.component';
import {BotatoChatInputDirective} from './botato-chat-input/botato-chat-input.directive';
import {TextInputComponent} from './botato-chat-input/input-type/text-input/text-input.component';
import {FileUploadComponent} from './botato-chat-input/input-type/file-upload/file-upload.component';
import {FilesMessageComponent} from './botato-chat-message/message-type/files-message/files-message.component';
import {ListInputComponent} from './botato-chat-input/input-type/list-input/list-input.component';
import {FormsModule} from '@angular/forms';
import {AutocompleteInputComponent} from './botato-chat-input/input-type/autocomplete-input/autocomplete-input.component';
import {MultiSelectionListMessageComponent} from './botato-chat-message/message-type/multiselection-list-message/multi-selection-list-message.component';
import {LinksMessageComponent} from './botato-chat-message/message-type/links-message/links-message.component';
import {ThinkingIndicatorComponent} from './botato-chat-message/message-type/thinking-indicator/thinking-indicator.component';
import {VoiceInputComponent} from './botato-chat-input/input-type/text-input/voice/voice-input.component';
import {HttpClientModule} from '@angular/common/http';
import {MarkdownPipe} from './service/markdown.pipe';
import {
    BotatoChatMessageIndicatorComponent
} from './botat-chat-elements/botato-chat-message-indicator/botato-chat-message-indicator.component';

@NgModule({
    declarations: [
        BotatoChatComponent,
        BotatoWidgetComponent,
        BotatoChatMessageComponent,
        BotatoChatInputComponent,
        ContenteditableModelDirective,
        TextMessageComponent,
        SelectionListMessageComponent,
        TypingIndicatorComponent,
        ImageMessageComponent,
        BotatoChatMessageDirective,
        BotatoChatInputDirective,
        TextInputComponent,
        FileUploadComponent,
        ListInputComponent,
        AutocompleteInputComponent,
        FilesMessageComponent,
        EmojiPipe,
        MarkdownPipe,
        MultiSelectionListMessageComponent,
        LinksMessageComponent,
        ThinkingIndicatorComponent,
        VoiceInputComponent,
        BotatoChatMessageIndicatorComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        TranslateModule.forChild(),
        FormsModule
    ],
    exports: [
        BotatoChatComponent,
        BotatoWidgetComponent,
        TranslateModule,
        EmojiPipe,
        MarkdownPipe
    ]
})
export class BotatoAngularLibBaseModule {

    constructor(translateService: TranslateService, @Inject('BOTATO_CONFIG') botatoConfig: BotatoConfig) {
        for (const language of botatoConfig.translations) {
            translateService.setTranslation(language.language, language.translations, true);
        }

        if (botatoConfig.defaultLanguage === undefined) {
            throw new Error('No defaultLanguage defined in BotatoConfig. You have to specify it in the BotatoConfig passed to the BotatoAngularLibLocalModule or BotatoAngularLibModule!');
        }

        if (!botatoConfig.translations.some(lang => lang.language === botatoConfig.defaultLanguage)) {
            throw new Error(`Could not find the defined defaultLanguage (${botatoConfig.defaultLanguage}) in the given list of translations. Available translations are: ${botatoConfig.translations.map(x => x.language).join(', ')}`);
        }

        translateService.use(botatoConfig.defaultLanguage);
    }
}
